import { render, staticRenderFns } from "./EditDocLABTxtKind.vue?vue&type=template&id=70295805&scoped=true"
import script from "./EditDocLABTxtKind.vue?vue&type=script&lang=js"
export * from "./EditDocLABTxtKind.vue?vue&type=script&lang=js"
import style0 from "./EditDocLABTxtKind.vue?vue&type=style&index=0&id=70295805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70295805",
  null
  
)

export default component.exports